export const formatDate = (date) => {
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  month = month < 10 ? "0" + month : month;
  day = day < 10 ? "0" + day : day;
  return `${month}${day}${year}`;
};

export const clinicalTrialAllowedOptions = (options) => {
  let allowed_values = [];
  options.map((item) => {
    switch (item) {
      case "optional":
        allowed_values.push("Optional");
        break;
      case "required":
        allowed_values.push("Required,Required_Infrastructure");
        break;
      case "besh":
        allowed_values.push("Basic_Trial");
        break;
    }
  });
  return allowed_values;
};

export const updateDataQueryHelper = (state, filters) => {
  let updateDataQuery = {
    perpage: filters.perpage ? filters.perpage : state.data_query.perpage,
    sort: filters.sort ? filters.sort : state.data_query.sort,
    from: filters.from ? filters.from : state.data_query.from,
    type: filters.type ? filters.type : state.data_query.type,
    parentic: filters.parentic ? filters.parentic : state.data_query.parentic,
    primaryic: filters.primaryic
      ? filters.primaryic
      : state.data_query.primaryic,
    activitycodes: filters.activitycodes
      ? filters.activitycodes
      : state.data_query.activitycodes,
    doctype: filters.doctype ? filters.doctype : state.data_query.doctype,
    parentfoa: filters.parentfoa
      ? filters.parentfoa
      : state.data_query.parentfoa,
    daterange: filters.daterange
      ? filters.daterange
      : state.data_query.daterange,
    clinicaltrials: filters.clinicaltrials
      ? filters.clinicaltrials
      : state.data_query.clinicaltrials,
    fields: filters.fields ? filters.fields : state.data_query.fields,
    spons: filters.spons !== undefined ? filters.spons : state.data_query.spons,
    query: filters.query ? filters.query : state.data_query.query,
    apptype: filters.apptype ? filters.apptype : state.data_query.apptype,
    researchInitiative: filters.researchInitiative ? filters.researchInitiative : state.data_query.researchInitiative,
    noticeSubject: filters.noticeSubject
      ? filters.noticeSubject
      : state.data_query.noticeSubject,
  };
  if (filters.from === 0) {
    updateDataQuery.from = 0;
  }
  if (filters.query === "") {
    updateDataQuery.query = "";
  }
  return updateDataQuery;
};

export const NOFOUrlGenerator = (filename) => {
  let url = "https://grants.nih.gov/grants/guide";
  if (filename.startsWith("NOT-") || filename.startsWith("not")) {
    url += "/notice-files/" + filename;
  }
  if (
    filename.startsWith("PA-") ||
    filename.startsWith("PAS-") ||
    filename.startsWith("PAR-")
  ) {
    url += "/pa-files/" + filename;
  }
  if (filename.startsWith("RFA-")) {
    url += "/rfa-files/" + filename;
  }

  return url;
};

export const commonAC = (codes) => {
  const filteredStrings = codes.filter(
    (str) => str.trim() !== "" && str.trim() !== "all"
  );
  if (filteredStrings.length > 0) {
    const arrays = filteredStrings.map((str) => new Set(str.split(",")));
    const intersection = Array.from(arrays[0]).filter((value) =>
      arrays.every((set) => set.has(value))
    );
    const commonElements = intersection.join(",");
    return commonElements;
  } else {
    return "all";
  }
};
